/**
 * 意见管理
 */
import React from 'react';
import UserList from "../userManage/UserList";
import $ from "jquery";
import {Button} from "antd";
import {formatDate} from "../../../utils";
import OpinionManageView from "./OpinionManageView";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";

export default class OpinionManageList extends UserList {

    getListData() {
        let params = {
            start: this.state.offsite,
            count: this.state.count,
            ...this.state.screenObj
        }
        this.request({
            url: "/cm-sites-mmp/Feedback/pageList",
            method: "get",
            body: params,
            callBack: (res) => {
                let listData = [];
                let hideOnSinglePage = true;
                let total = 0;
                if (res && res.data && res.data.length) {
                    listData = res.data;
                    total = res.count;
                    hideOnSinglePage = false;
                }
                this.setState({
                    listData,
                    total,
                    hideOnSinglePage
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            }
        });
    }

    getScreenList() {
        return (
            [
                {
                    key: "message",
                    field: "message",
                    placeholder: "请输入反馈信息",
                    type: "1",
                }
            ]
        )
    }

    getColumns() {
        return (
            [
                {
                    title: "问题类型",
                    key: 'type',
                    dataIndex: 'type',
                    width: 150,
                    render: (text, record) => {
                        return(
                            <div style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                                {(() => {
                                    switch (text) {
                                        case 1: return "功能bug";
                                        case 2: return "内容性建议";
                                        case 3: return "其他问题";
                                        default: return "";
                                    }
                                })()}
                            </div>
                        )
                    }
                },
                {
                    title: "反馈信息",
                    key: 'message',
                    dataIndex: 'message',
                    ellipsis: true,
                },
                {
                    title: "提交人",
                    key: 'submitUser',
                    dataIndex: 'submitUser',
                    ellipsis: true,
                },
                {
                    title: "手机号码",
                    key: 'submitUserPhone',
                    dataIndex: 'submitUserPhone',
                    ellipsis: true,
                },
                {
                    title: "提交时间",
                    key: 'createTime',
                    dataIndex: 'createTime',
                    ellipsis: true,
                    width: 180,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{text ? formatDate(text) : ""}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 100,
                    render: (text, record) => {
                        return (
                            <div>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.OpinionManageView.show(record)}>查看</span>
                            </div>
                        )
                    }
                }
            ]
        )
    }

    renderAddModal() {
        return (
            <OpinionManageView ref={(OpinionManageView) => this.OpinionManageView = OpinionManageView}/>
        )
    }

    renderBtn() {
        return (
            <div style={{marginTop: 20}}>
                <Button style={{marginRight: "20px"}} onClick={() => {
                    this.exportOpinion()
                }}>
                    导出
                </Button>
            </div>
        )
    }

    exportOpinion() {
        let params = {
            ...this.state.screenObj
        }
        this.request({
            url: "/cm-sites-mmp/Feedback/outputFeedback",
            method: "downloadGet",
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success("导出成功");
                }
            }
        });
    }
}